import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, type ButtonSize, type ButtonVariant } from "./base/button";

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

/** An anchor tag which looks like a button. */
export function AButton({
  href,
  onClick,
  className,
  variant = "default",
  size = "default",
  children,
  ...rest
}: Props) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (rest.target) {
      onClick?.(e);
      return;
    }
    e.preventDefault();
    void navigate(href);
    onClick?.(e);
  };

  return (
    <Button asChild variant={variant} size={size} className={className}>
      <a {...rest} href={href} onClick={handleClick}>
        {children}
      </a>
    </Button>
  );
}
